import { Skeleton, Card, Row, Col } from 'antd';
import '@components/ContentSkeleton.scss';

interface ContentSkeletonProps {
  type: 'about' | 'experience' | 'skills' | 'projects' | 'contact';
}

export const ContentSkeleton = ({ type }: ContentSkeletonProps) => {
  const renderAboutSkeleton = () => (
    <div className="skeleton-about">
      <Skeleton.Input active block style={{ width: '60%', marginBottom: '2rem' }} />
      <Skeleton paragraph={{ rows: 3 }} active />
      <Row gutter={[24, 24]} className="skeleton-cards">
        {[1, 2, 3].map((key) => (
          <Col xs={24} sm={8} key={key}>
            <Card>
              <Skeleton avatar active paragraph={{ rows: 2 }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const renderExperienceSkeleton = () => (
    <div className="skeleton-experience">
      <Skeleton.Input active block style={{ width: '40%', marginBottom: '2rem' }} />
      {[1, 2, 3].map((key) => (
        <Card key={key} style={{ marginBottom: '1rem' }}>
          <Skeleton active paragraph={{ rows: 3 }} />
        </Card>
      ))}
    </div>
  );

  const renderSkillsSkeleton = () => (
    <div className="skeleton-skills">
      <Skeleton.Input active block style={{ width: '40%', marginBottom: '2rem' }} />
      <Row gutter={[24, 24]}>
        {[1, 2, 3].map((key) => (
          <Col xs={24} md={8} key={key}>
            <Card>
              <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const renderProjectsSkeleton = () => (
    <div className="skeleton-projects">
      <Skeleton.Input active block style={{ width: '40%', marginBottom: '2rem' }} />
      <Row gutter={[24, 24]}>
        {[1, 2, 3].map((key) => (
          <Col xs={24} md={12} lg={8} key={key}>
            <Card
              cover={
                <Skeleton.Image active style={{ width: '100%', height: 200 }} />
              }
            >
              <Skeleton active paragraph={{ rows: 3 }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const renderContactSkeleton = () => (
    <div className="skeleton-contact">
      <Skeleton.Input active block style={{ width: '40%', marginBottom: '2rem' }} />
      <Row gutter={[24, 24]}>
        {[1, 2, 3].map((key) => (
          <Col xs={24} md={8} key={key}>
            <Card>
              <Skeleton.Avatar active size="large" shape="circle" />
              <Skeleton active paragraph={{ rows: 2 }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const skeletonMap = {
    about: renderAboutSkeleton,
    experience: renderExperienceSkeleton,
    skills: renderSkillsSkeleton,
    projects: renderProjectsSkeleton,
    contact: renderContactSkeleton,
  };

  return skeletonMap[type]();
};

export default ContentSkeleton;